module.exports = __webpack_public_path__ + "img/trophy.acae40f7.svg";